import { AllyUtil } from "../util/ally-util.class";
import { AllyBridge } from "./ally-bridge.class";
import { AllyDestroyer } from "./ally-destroyer.class";

/**
 * The base class for all other classes.
 * 
 * The class implements the hierarchical structure for the AllyDestroyer class and creates the bridge function necessary for said structure.
 * 
 * @extends AllyBridge<AllyBase>
 * @see AllyDestroyer
 */
export class AllyBase extends AllyBridge<AllyBase> {
    /**
     * The root element of the hierarchical structure.
     * 
     * @see AllyDestroyer
     */
    protected static root: AllyBase = new AllyBase(() => AllyBase.root);
    /**
     * The bridge to the root element of the hierarchical structure.
     * 
     * @see AllyDestroyer
     */
    protected static bridge: () => AllyBase = () => AllyBase.root;
    /**
     * The AllyDestroyer object of this AllyBase object.
     *
     * @see AllyDestroyer
     */
    public destroyer: AllyDestroyer;

    public get destroyed(): boolean {
        return this.destroyer?.destroyed ?? false;
    }

    /**
     * @param bridge The bridge to the parent object.
     */
    constructor(bridge: () => AllyBase) {
        super(() => this);
        this.destroyer = null as unknown as AllyDestroyer;
        AllyUtil.delay(!bridge(), () => {
            this.destroyer = new AllyDestroyer(() => bridge().destroyer);
        });
    }

    /** Moves the object below another parent in the hierarchical structure. */
    public reparentDestroyer(bridge: () => AllyBase) {
        this.destroyer?.reparent(() => bridge().destroyer);
    }

    /**
     * Destroys the object (triggers all destroyer callbacks).
     * 
     * @see AllyDestroyer
     */
    public destroy() {
        this.destroyer.destroy();
    }
}